import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '../views/indexView.vue'
import { updateSEO, getDefaultSEO } from '../utils/seo'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: IndexView,
    meta: {
      title: '明晟环保官网 - 氨法脱硫与烟气治理专家-绿色低碳环保解决方案服务商',
      keywords: '明晟环保，山东明晟环保，氨法脱硫，脱硫脱硝，烟气治理，环保设备，超低排放，环保工程，压力容器，轮胎裂解，烟气插板阀，项目安装，项目运维',
      description: '山东明晟环保专注工业烟气治理、氨法脱硫脱硝、环保设备及压力容器制造、项目安装、项目运维等环保技术研发与落地。提供超低排放解决方案与环保工程 EPC 服务，为企业绿色发展保驾护航。'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/AboutView.vue'),
    meta: {
      title: '关于明晟环保 - 明晟集团公司介绍-研发团队80+专利100+_氨法脱硫烟气治理环保标杆企业',
      keywords: '明晟环保介绍，山东明晟环保，环保公司，环保工程公司，烟气治理企业，明晟环保研发团队,明晟环保专利,明晟环保资质,氨法脱硫,烟气治理,环保企业发展历程',
      description: '山东明晟环保科技有限公司是专业从事烟气治理、脱硫脱硝、环保设备制造与工程总包的高新技术企业，拥有研发团队80+、自主专利100+，拥有环境工程设计专项 (大气污染防治工程) 甲级资质; 环保工程专业承包壹级资质，涵盖公司介绍、董事长寄语、企业使命及完整发展历程，致力于以创新技术打造绿色低碳环保标杆，为工业企业提供专业环保解决方案。'
    }
  },
  {
    path: '/show',
    name: 'Show',
    component: () => import('../views/ShowView.vue'),
    meta: {
      title: '媒体中心 | 明晟环保 - 新闻动态、行业资讯、媒体报道',
      keywords: '明晟新闻，环保行业资讯，脱硫脱硝新闻，环保政策，公司动态',
      description: '关注明晟环保最新动态、环保行业政策、脱硫脱硝技术进展与项目资讯，了解环保行业发展趋势。'
    }
  },
  {
    path: '/achievement',
    name: 'Achievement',
    component: () => import('../views/YejiView.vue'),
    meta: {
      title: '明晟环保-项目案例_氨法脱硫|轮胎裂解|压力容器|烟气插板阀项目安装运维成功案例展示',
      keywords: '明晟环保,项目案例,氨法脱硫项目案例,轮胎裂解项目案例,烟气插板阀案例,压力容器项目案例,项目安装案例,项目运维案例,工业环保项目案例,环保工程案例',
      description: '明晟环保项目案例中心，汇集氨法脱硫、轮胎裂解、烟气插板阀、定制化压力容器等各类工业环保项目成功案例，涵盖项目安装、全程运维全流程落地案例，真实呈现100+专利技术应用成效、80+研发团队技术实力，覆盖多行业场景，详细展示项目实施细节、达标效果与客户认可，见证明晟环保工业环保全流程服务实力，为企业提供可参考、可复制的环保项目解决方案。'
    }
  },
  {
    path: '/sustainable',
    name: 'sustainable',
    component: () => import('../views/SustainableView.vue'),
    meta: {
      title: '可持续发展 - 山东明晟环保科技有限公司 | 绿色低碳・环保创新・社会责任',
      keywords: '明晟环保，可持续发展，绿色低碳，环保创新，社会责任，生态环保，氨法脱硫，循环经济，环保产业发展',
      description: '晟环保集团以绿色低碳为导向，积极推进可持续发展战略，聚焦环保技术创新、资源循环利用、生态保护与社会责任担当，通过氨法脱硫、烟气治理、循环经济等核心业务，助力产业绿色转型，共建可持续发展的生态未来。'
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/NewsView.vue'),
    meta: {
      title: '媒体中心 | 明晟环保 - 新闻动态、行业资讯、媒体报道',
      keywords: '明晟新闻，环保行业资讯，脱硫脱硝新闻，环保政策，公司动态',
      description: '关注明晟环保最新动态、环保行业政策、脱硫脱硝技术进展与项目资讯，了解环保行业发展趋势。'
    }
  },
  {
    path: '/personnel',
    name: 'personnel',
    component: () => import('../views/PersonView.vue'),
    meta: {
      title: '人才发展-山东明晟环保科技有限公司_环保人才招聘_企业文化与人才成长平台',
      keywords: '明晟环保,人才发展,明晟环保招聘,环保行业人才,脱硫脱硝人才,环保设备研发人才,压力容器技术人才,环保人才成长,明晟环保企业文化,明晟人才价值观,明晟之星,系统思维,主人意识',
      description: '欢迎加入山东明晟环保科技有限公司人才发展平台，依托公司研究院技术优势，聚焦脱硫脱硝、烟气治理、环保设备及压力容器领域。公司秉持“系统思维、主人意识、放大格局、干中求进”的人才价值观，深耕企业文化建设，设有“明晟之星”特色板块，为各类人才提供广阔成长空间、完善培育体系与优质发展机遇，同步开展人才招聘工作，诚邀志同道合者共筑绿色环保事业。'
    }
  },
  {
    path: '/carrer',
    name: 'carrer',
    component: () => import('../views/CarrerView.vue'),
    meta: {
      title: '人才发展-山东明晟环保科技有限公司_环保人才招聘_企业文化与人才成长平台',
      keywords: '明晟环保,人才发展,明晟环保招聘,环保行业人才,脱硫脱硝人才,环保设备研发人才,压力容器技术人才,环保人才成长,明晟环保企业文化,明晟人才价值观,明晟之星,系统思维,主人意识',
      description: '欢迎加入山东明晟环保科技有限公司人才发展平台，依托公司研究院技术优势，聚焦脱硫脱硝、烟气治理、环保设备及压力容器领域。公司秉持“系统思维、主人意识、放大格局、干中求进”的人才价值观，深耕企业文化建设，设有“明晟之星”特色板块，为各类人才提供广阔成长空间、完善培育体系与优质发展机遇，同步开展人才招聘工作，诚邀志同道合者共筑绿色环保事业。'
    }
  },
  {
    path: '/case',
    name: 'case',
    component: () => import('../views/CaseView.vue'),
    meta: {
      title: '明晟环保-项目案例_氨法脱硫|轮胎裂解|压力容器|烟气插板阀项目安装运维成功案例展示',
      keywords: '明晟环保,项目案例,氨法脱硫项目案例,轮胎裂解项目案例,烟气插板阀案例,压力容器项目案例,项目安装案例,项目运维案例,工业环保项目案例,环保工程案例',
      description: '明晟环保项目案例中心，汇集氨法脱硫、轮胎裂解、烟气插板阀、定制化压力容器等各类工业环保项目成功案例，涵盖项目安装、全程运维全流程落地案例，真实呈现100+专利技术应用成效、80+研发团队技术实力，覆盖多行业场景，详细展示项目实施细节、达标效果与客户认可，见证明晟环保工业环保全流程服务实力，为企业提供可参考、可复制的环保项目解决方案。'
    }
  },
  {
    path: '/show2',
    name: 'show2',
    component: () => import('../views/Show2View.vue'),
    meta: {
      title: '详情 | 明晟环保 - 产品介绍、技术参数、应用案例',
      keywords: '详情,介绍,技术参数,应用案例,环保产品,设备详情',
      description: '明晟环保详情页面，介绍各类环保设备的技术参数、应用场景和成功案例，为您的环保需求提供专业解决方案。'
    }
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/ProductView.vue'),
    meta: {
      title: '明晟环保-产品中心-氨法脱硫设备-轮胎裂解系统-烟气插板阀-压力容器定制=专业项目安装-环保运维服务-工业环保全流程服务商',
      keywords: '明晟环保,产品中心,氨法脱硫,氨法脱硫设备,轮胎裂解,轮胎裂解系统,烟气插板阀,压力容器,压力容器定制,项目安装,项目运维,工业环保产品,环保项目服务,工业环保服务商',
      description: '明晟环保产品中心，聚焦工业环保全流程需求，涵盖氨法脱硫设备（高效节能、达标排放）、轮胎裂解系统（绿色资源化）、烟气插板阀（耐磨耐用、密封性强）、定制化压力容器等全系列优质环保产品，同步提供专业项目安装、全程运维托管服务，依托企业研发实力与丰富项目经验，以标准化产品、精细化服务，一站式助力工业企业实现绿色低碳转型、环保达标生产。'
    }
  },
  {
    path: '/productOne',
    name: 'productOne',
    component: () => import('../views/ProductOne.vue'),
    meta: {
      title: '氨法脱硫 | 明晟环保',
      keywords: '明晟环保,产品中心,氨法脱硫,氨法脱硫设备,轮胎裂解,轮胎裂解系统,烟气插板阀,压力容器,压力容器定制,项目安装,项目运维,工业环保产品,环保项目服务,工业环保服务商',
      description: '明晟环保产品中心，聚焦工业环保全流程需求，涵盖氨法脱硫设备（高效节能、达标排放）、轮胎裂解系统（绿色资源化）、烟气插板阀（耐磨耐用、密封性强）、定制化压力容器等全系列优质环保产品，同步提供专业项目安装、全程运维托管服务，依托企业研发实力与丰富项目经验，以标准化产品、精细化服务，一站式助力工业企业实现绿色低碳转型、环保达标生产。'
    }
  },
  {
    path: '/productTwo',
    name: 'productTwo',
    component: () => import('../views/ProductTwo.vue'),
    meta: {
      title: '烟道插板阀 | 明晟环保',
      keywords: '明晟环保,产品中心,氨法脱硫,氨法脱硫设备,轮胎裂解,轮胎裂解系统,烟气插板阀,压力容器,压力容器定制,项目安装,项目运维,工业环保产品,环保项目服务,工业环保服务商',
      description: '明晟环保产品中心，聚焦工业环保全流程需求，涵盖氨法脱硫设备（高效节能、达标排放）、轮胎裂解系统（绿色资源化）、烟气插板阀（耐磨耐用、密封性强）、定制化压力容器等全系列优质环保产品，同步提供专业项目安装、全程运维托管服务，依托企业研发实力与丰富项目经验，以标准化产品、精细化服务，一站式助力工业企业实现绿色低碳转型、环保达标生产。'
    }
  },
  {
    path: '/productThree',
    name: 'productThree',
    component: () => import('../views/ProductThree.vue'),
    meta: {
      title: '轮胎裂解 | 明晟环保',
      keywords: '明晟环保,产品中心,氨法脱硫,氨法脱硫设备,轮胎裂解,轮胎裂解系统,烟气插板阀,压力容器,压力容器定制,项目安装,项目运维,工业环保产品,环保项目服务,工业环保服务商',
      description: '明晟环保产品中心，聚焦工业环保全流程需求，涵盖氨法脱硫设备（高效节能、达标排放）、轮胎裂解系统（绿色资源化）、烟气插板阀（耐磨耐用、密封性强）、定制化压力容器等全系列优质环保产品，同步提供专业项目安装、全程运维托管服务，依托企业研发实力与丰富项目经验，以标准化产品、精细化服务，一站式助力工业企业实现绿色低碳转型、环保达标生产。'
    }
  },
  {
    path: '/productFour',
    name: 'productFour',
    component: () => import('../views/ProductFour.vue'),
    meta: {
      title: '压力容器 | 明晟环保',
      keywords: '明晟环保,产品中心,氨法脱硫,氨法脱硫设备,轮胎裂解,轮胎裂解系统,烟气插板阀,压力容器,压力容器定制,项目安装,项目运维,工业环保产品,环保项目服务,工业环保服务商',
      description: '明晟环保产品中心，聚焦工业环保全流程需求，涵盖氨法脱硫设备（高效节能、达标排放）、轮胎裂解系统（绿色资源化）、烟气插板阀（耐磨耐用、密封性强）、定制化压力容器等全系列优质环保产品，同步提供专业项目安装、全程运维托管服务，依托企业研发实力与丰富项目经验，以标准化产品、精细化服务，一站式助力工业企业实现绿色低碳转型、环保达标生产。'
    }
  },
  {
    path: '/productFive',
    name: 'productFive',
    component: () => import('../views/ProductFive.vue'),
    meta: {
      title: '工程安装 | 明晟环保',
      keywords: '明晟环保,产品中心,氨法脱硫,氨法脱硫设备,轮胎裂解,轮胎裂解系统,烟气插板阀,压力容器,压力容器定制,项目安装,项目运维,工业环保产品,环保项目服务,工业环保服务商',
      description: '明晟环保产品中心，聚焦工业环保全流程需求，涵盖氨法脱硫设备（高效节能、达标排放）、轮胎裂解系统（绿色资源化）、烟气插板阀（耐磨耐用、密封性强）、定制化压力容器等全系列优质环保产品，同步提供专业项目安装、全程运维托管服务，依托企业研发实力与丰富项目经验，以标准化产品、精细化服务，一站式助力工业企业实现绿色低碳转型、环保达标生产。'
    }
  },
  {
    path: '/productSix',
    name: 'productSix',
    component: () => import('../views/ProductSix.vue'),
    meta: {
      title: '运维服务 | 明晟环保',
      keywords: '明晟环保,产品中心,氨法脱硫,氨法脱硫设备,轮胎裂解,轮胎裂解系统,烟气插板阀,压力容器,压力容器定制,项目安装,项目运维,工业环保产品,环保项目服务,工业环保服务商',
      description: '明晟环保产品中心，聚焦工业环保全流程需求，涵盖氨法脱硫设备（高效节能、达标排放）、轮胎裂解系统（绿色资源化）、烟气插板阀（耐磨耐用、密封性强）、定制化压力容器等全系列优质环保产品，同步提供专业项目安装、全程运维托管服务，依托企业研发实力与丰富项目经验，以标准化产品、精细化服务，一站式助力工业企业实现绿色低碳转型、环保达标生产。'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  // 路由始终以当前站点根路径为基准，不跟随静态资源 publicPath（避免拼上 OSS 域名）
  base: '/',
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 如果有保存的位置（比如浏览器前进后退），则使用保存的位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 如果有 hash，优先滚动到锚点位置
      if (to.hash) {
        // 使用 Promise 确保在页面渲染完成后滚动
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({ selector: to.hash })
          }, 100)
        })
      }
      // 否则滚动到页面顶部（使用 Promise 确保在页面渲染完成后滚动）
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 })
        }, 100)
      })
    }
  }
})

// 路由守卫：自动更新 SEO 信息
router.beforeEach((to, from, next) => {
  // 获取路由的 meta 信息
  const seoInfo = to.meta || {}
  
  // 如果路由有 SEO 配置，则更新；否则使用默认配置
  if (seoInfo.title || seoInfo.keywords || seoInfo.description) {
    updateSEO({
      title: seoInfo.title || getDefaultSEO().title,
      keywords: seoInfo.keywords || getDefaultSEO().keywords,
      description: seoInfo.description || getDefaultSEO().description
    })
  } else {
    // 使用默认 SEO 配置
    updateSEO(getDefaultSEO())
  }
  
  next()
})

export default router

